<template>
  <div class="attached-toolbar-container">
    <template v-if="props.toolbarCount <= 3">
      <template v-for="(_, slotName) in slots" :key="slotName">
        <div class="toolbar-item">
          <slot :name="slotName" />
          <div class="divider"></div>
        </div>
      </template>
    </template>

    <!-- if toolbar count is more than 3, show first two items and move the rest to overflow menu -->
    <template v-else>
      <template v-for="(_, slotName, index) in slots" :key="slotName">
        <div v-if="index <= 1" class="toolbar-item">
          <slot :name="slotName" />
          <div class="divider"></div>
        </div>
      </template>

      <overflow-menu :flip-menu="true">
        <template #trigger>
          <svg-icon name="Kebab24" kind="action" />
        </template>

        <template v-for="(_, slotName, index) in slots" :key="slotName">
          <div v-if="index > 1">
            <overflow-menu-item>
              <slot :name="slotName" />
            </overflow-menu-item>
          </div>
        </template>
      </overflow-menu>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useSlots } from "vue";

interface Props {
  toolbarCount?: number;
}

const props = withDefaults(defineProps<Props>(), {
  toolbarCount: 1,
});

const slots = useSlots();
</script>

<style lang="scss">
@use "carbon-components/scss/globals/scss/motion.scss" as *;
@use "@styles/layout/breakpoint" as *;
@use "@styles/layout/z-map" as *;
@use "@styles/themes/sls-theme/tokens/colors" as *;
@use "@styles/themes/sls-theme/tokens/effects" as *;
@use "@styles/themes/sls-theme/tokens/spacing" as *;

.attached-toolbar-container {
  background-color: $ui-01;
  box-shadow: $shadow-01;
  border-radius: 10px;
  z-index: z-map("attached-toolbar");
  transition: all $duration--fast-01 motion(standard, productive);

  .toolbar-item {
    &:first-child {
      .attached-toolbar {
        border-radius: 10px 10px 0 0;
      }
    }

    &:last-child {
      .attached-toolbar {
        border-radius: 0 0 10px 10px;
      }

      .divider {
        display: none;
      }
    }

    &:only-child {
      .attached-toolbar {
        border-radius: 10px;
      }
    }

    .divider {
      margin: 0 $spacing-03;
      border-top: $divider-02;
    }
  }

  .bx--overflow-menu {
    border-radius: 10px;

    @include media("tablet-min") {
      width: 48px;
      height: 48px;
    }

    .bx--overflow-menu__trigger {
      &.bx--tooltip--a11y.bx--tooltip__trigger {
        background: none;
        border-radius: 10px;

        &:focus {
          border: 0;
        }
      }
    }
  }
}
</style>
